/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/components/dialogs/manage-business-profile-roles-dialog/manage-business-profile-roles-dialog.component.scss */
/*# sourceMappingURL=manage-business-profile-roles-dialog.component.css.map */
